// TRB DYMO — Pro design, 89x36mm, USD only, barcode on right, auto-fit
(function(){
  const W=document, $=id=>W.getElementById(id);
  const esc=s=>(s??"").toString().replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#39;");
  const norm=s=>(s||"").toString().trim();

  // Load JsBarcode once
  function loadJsBarcode(cb){ if(window.JsBarcode) return cb(); const s=W.createElement("script");
    s.src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.6/dist/JsBarcode.all.min.js"; s.onload=cb; W.head.appendChild(s); }

  // CSV (quotes + multiline)
  function parseCSV(text){
    const out=[], lines=text.split(/\r?\n/); let row=[], field="", q=false;
    const pushF=()=>{row.push(field);field="";}, pushR=()=>{out.push(row.slice());row.length=0;};
    for(const line of lines){
      for(let i=0;i<line.length;i++){
        const ch=line[i];
        if(q){ if(ch=='"'&&line[i+1]=='"'){field+='"';i++;} else if(ch=='"'){q=false;} else field+=ch; }
        else { if(ch=='"'){q=true;} else if(ch==','){pushF();} else field+=ch; }
      }
      if(q){ field+="\n"; } else { pushF(); pushR(); }
    }
    return out;
  }

  const state={ labels: JSON.parse(localStorage.getItem("trb_labels_pro_v1")||"[]"), selected:new Set() };
  const save = ()=> localStorage.setItem("trb_labels_pro_v1", JSON.stringify(state.labels));
  const updateCount = ()=>{ const el=$("trb-count"); if(el) el.textContent = `${state.labels.length} labels`; };

  function drawBarcodes(scope){
    if(!window.JsBarcode) return;
    (scope||W).querySelectorAll("svg.trb-barcode").forEach(svg=>{
      const v=svg.getAttribute("data-val");
      if(!v){ svg.outerHTML='<div style="font-size:9px;color:#64748b">No barcode</div>'; return; }
      try{ JsBarcode(svg, v, {format:"CODE128", displayValue:true, fontSize:9, textMargin:1, margin:0}); }
      catch(e){ svg.outerHTML='<div style="font-size:9px;color:#b91c1c">Invalid barcode</div>'; }
    });
  }

  function cardHTML(L, idx){
    const cod = L.cod_usd ? ('$ ' + L.cod_usd) : '';
    return `
      <div class="preview-wrap" data-idx="${idx}">
        <div class="card-tools trb-noprint">
          <button class="card-btn" data-act="toggle">${state.selected.has(idx)?'Unselect':'Select'}</button>
          <button class="card-btn" data-act="print">Print</button>
          <button class="card-btn" data-act="dup">Duplicate</button>
          <button class="card-btn warn" data-act="del">Delete</button>
        </div>
        <div class="preview-scale">
          <div class="preview">
            <div class="head">
              <div class="order">Order: ${esc(L.order||"—")}</div>
              <div class="cod"><span class="sym">$</span><span class="amt">${esc(L.cod_usd||"")}</span></div>
            </div>

            <div class="textcol">
              <div class="kv"><div class="k">NAME</div><div class="v">${esc(L.name||"")}</div></div>
              <div class="kv"><div class="k">ADDRESS</div><div class="v">${esc(L.address||"")}</div></div>
              <div class="kv"><div class="k">PHONE</div><div class="v">${esc(L.phone||"")}</div></div>
              ${L.notes?`<div class="kv"><div class="k">NOTES</div><div class="v">${esc(L.notes)}</div></div>`:""}
            </div>

            <div class="barcodecol">
              <svg class="trb-barcode" data-val="${esc(norm(L.order))}"></svg>
            </div>
          </div>
        </div>
      </div>`;
  }

  function render(){
    const wrap=$("trb-labels"); if(!wrap) return;
    wrap.innerHTML = state.labels.map((L,i)=>cardHTML(L,i)).join("");

    wrap.querySelectorAll(".card-btn").forEach(btn=>{
      btn.addEventListener("click", ev=>{
        ev.preventDefault(); ev.stopPropagation();
        const idx=Number(btn.closest(".preview-wrap").dataset.idx);
        const act=btn.dataset.act, L=state.labels[idx];
        if(act==="del"){ state.labels.splice(idx,1); save(); render(); }
        else if(act==="dup"){ state.labels.splice(idx+1,0,{...L, ts:Date.now()}); save(); render(); }
        else if(act==="print"){ printMany([L]); }
        else if(act==="toggle"){ state.selected.has(idx)?state.selected.delete(idx):state.selected.add(idx); render(); }
      });
    });

    wrap.querySelectorAll(".preview-wrap").forEach(card=>{
      card.addEventListener("click", e=>{
        if(e.target.closest(".card-btn")) return;
        const idx=Number(card.dataset.idx);
        state.selected.has(idx)?state.selected.delete(idx):state.selected.add(idx);
        render();
      });
    });

    updateCount();
    loadJsBarcode(()=>drawBarcodes(wrap));
  }

  // ------- PRINT (exact size + tiny auto-fit on text column) -------
  function buildPrintHTML(items){
    const rows = items.map(L=>`
      <div class="print-label">
        <div class="print-head">
          <div class="print-order">Order: ${esc(L.order||"")}</div>
          <div class="print-cod">$ ${esc(L.cod_usd||"")}</div>
        </div>

        <div class="print-textcol">
          <div class="print-kv"><div class="print-k">NAME</div><div class="print-v">${esc(L.name||"")}</div></div>
          <div class="print-kv"><div class="print-k">ADDRESS</div><div class="print-v">${esc(L.address||"")}</div></div>
          <div class="print-kv"><div class="print-k">PHONE</div><div class="print-v">${esc(L.phone||"")}</div></div>
          ${L.notes?`<div class="print-kv"><div class="print-k">NOTES</div><div class="print-v">${esc(L.notes)}</div></div>`:""}
        </div>

        <div class="print-barcode">
          <svg class="barcode" data-val="${esc(norm(L.order))}"></svg>
        </div>
      </div>`).join("");

    return `<!DOCTYPE html><html><head><meta charset="utf-8">
<title>Print</title>
<style>
  @page{ size: 89mm 36mm; margin:0 }
  body{ margin:0; font-family:system-ui,-apple-system,"Segoe UI",Roboto,Arial,sans-serif }
  .print-label{
    width:89mm; height:36mm; page-break-after:always; padding:3mm; display:grid; gap:0.6mm;
    grid-template-columns: 1fr 22mm; grid-template-rows: auto 1fr; column-gap:2mm;
  }
  .print-head{
    grid-column:1 / span 2; display:grid; grid-template-columns:1fr auto; align-items:center;
    border-bottom: 0.3mm solid #000; padding-bottom:0.6mm
  }
  .print-order{font-size:7pt}
  .print-cod{font-weight:900; font-size:9.2pt; border:0.2mm solid #000; padding:0.8mm 1.6mm; border-radius:4px}
  .print-textcol{ display:grid; gap:0.3mm; align-content:start; transform-origin: top left }
  .print-kv{ display:grid; grid-template-columns:22mm 1fr; column-gap:2mm; row-gap:0.2mm }
  .print-k{ font-size:7pt; font-weight:800 }
  .print-v{ font-size:8.2pt; white-space:pre-line; font-weight:700; line-height:1.12 }
  .print-barcode{ display:flex; align-items:center; justify-content:center }
  svg.barcode{ height:27mm; width:18mm; transform: rotate(-90deg); }
</style>
</head><body>${rows}
<script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.6/dist/JsBarcode.all.min.js"><\/script>
<script>
  function fit(col){
    let s = 1.0; col.style.transform = "scale("+s+")";
    while (s > 0.85 && col.scrollHeight > col.clientHeight) { s -= 0.02; col.style.transform = "scale("+s+")"; }
  }
  document.querySelectorAll('svg.barcode').forEach(el=>{
    const v = el.getAttribute('data-val');
    if(v){ try{ JsBarcode(el, v, {format:'CODE128', displayValue:true, fontSize:9, textMargin:1, margin:0}); }catch(e){} }
  });
  window.onload = function(){ document.querySelectorAll('.print-textcol').forEach(fit); setTimeout(()=>window.print(), 80); };
<\/script>
</body></html>`;
  }

  function printMany(items){
    const html=buildPrintHTML(items);
    const w=window.open("","_blank"); w.document.write(html); w.document.close(); w.focus();
  }

  // ------- form & actions -------
  function grabForm(){
    const g=id=>($(id)?.value||"").trim();
    const L={ name:g("trb-name"), address:g("trb-address"), phone:g("trb-phone"),
              order:g("trb-order"), cod_usd:g("trb-cod-usd"), notes:g("trb-notes"), ts:Date.now() };
    if(!(L.name||L.address||L.phone||L.order||L.cod_usd||L.notes)){ alert("Fill at least one field."); return null; }
    return L;
  }
  function clearForm(){ ["trb-name","trb-address","trb-phone","trb-order","trb-cod-usd","trb-notes"].forEach(id=>{ const el=$(id); if(el) el.value=""; }); }

  function wire(){
    $("trb-add").addEventListener("click", ()=>{ const L=grabForm(); if(!L) return; state.labels.push(L); save(); render(); clearForm(); });
    $("trb-addAndPrint").addEventListener("click", ()=>{ const L=grabForm(); if(!L) return; state.labels.push(L); save(); render(); clearForm(); printMany([L]); });
    $("trb-printAll").addEventListener("click", ()=>{ if(!state.labels.length) return alert("No labels to print."); printMany(state.labels); });
    $("trb-printSelected").addEventListener("click", ()=>{
      const arr=[...state.selected].sort((a,b)=>a-b).map(i=>state.labels[i]); if(!arr.length) return alert("No selected labels."); printMany(arr);
    });
    $("trb-clearAll").addEventListener("click", ()=>{ if(!state.labels.length) return; if(confirm("Delete all labels?")){ state.labels=[]; state.selected.clear(); save(); render(); } });
    $("trb-exportJSON").addEventListener("click", ()=>{
      const blob=new Blob([JSON.stringify(state.labels,null,2)],{type:"application/json"});
      const a=W.createElement("a"); a.href=URL.createObjectURL(blob); a.download="labels.json"; a.click();
    });
    $("trb-importJSON").addEventListener("click", ()=>{
      const inp=W.createElement("input"); inp.type="file"; inp.accept="application/json";
      inp.onchange=e=>{
        const f=e.target.files[0]; if(!f)return;
        const r=new FileReader();
        r.onload=()=>{
          try{
            const data=JSON.parse(r.result);
            if(!Array.isArray(data)) throw new Error("Invalid file");
            state.labels=data.map(x=>({name:"",address:"",phone:"",order:"",cod_usd:"",notes:"",ts:Date.now(),...x}));
            save(); render();
          }catch(err){ alert("Import failed: "+err.message); }
        };
        r.readAsText(f);
      };
      inp.click();
    });
    $("trb-importCSV").addEventListener("click", ()=>{
      const txt=$("trb-csv").value.trim(); if(!txt) return alert("Paste CSV first.");
      const rows=parseCSV(txt), added=[];
      for(const r of rows){
        const [name,address,phone,order,cod_usd,notes]=r;
        if(!(name||address||phone||order||cod_usd||notes)) continue;
        added.push({name,address,phone,order,cod_usd,notes,ts:Date.now()});
      }
      if(!added.length) return alert("No valid rows.");
      state.labels.push(...added); save(); render(); $("trb-csv").value="";
    });
    $("trb-sample").addEventListener("click", ()=>{
      $("trb-csv").value = `Mariam Haddad,"Hamra, Bliss St
Beirut",+96176915030,TRB-10542,40,Fragile
Ali K,"Saida – Main Rd
South",+96170123456,TRB-10543,0,Call before`;
    });
  }

  function init(){ wire(); updateCount(); render(); }
  if(document.readyState==="loading"){ document.addEventListener("DOMContentLoaded", init); } else { init(); }
})();
